import { render, staticRenderFns } from "./AuthInvite.vue?vue&type=template&id=6f720b47&"
import script from "./AuthInvite.vue?vue&type=script&lang=js&"
export * from "./AuthInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f720b47')) {
      api.createRecord('6f720b47', component.options)
    } else {
      api.reload('6f720b47', component.options)
    }
    module.hot.accept("./AuthInvite.vue?vue&type=template&id=6f720b47&", function () {
      api.rerender('6f720b47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthInvite.vue"
export default component.exports